// extracted by mini-css-extract-plugin
module.exports = {"gameContainer":"MissionElements_gameContainer__2grxc","back-btn-container":"MissionElements_back-btn-container__2KKIU"};